import React, { useState } from "react";
import { uri } from "../../../../../help/Api";
import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost";
import { useEffect } from "react";
import { insh, sto } from "../../../../../Context/InshData";
import BackdropScI from "../../../../../services/BackdropScI";
import EExchangeVoucher from "./EExchangeVoucher";
import dataF from "../../../../../Server/dataF.json"
import { Dialog } from "@material-ui/core";
import { useTranslation } from "react-i18next";


export default function EExchangeVoucherDialog(props) {

  const { open, onClose, onSave, invData } = props;
  const { t } = useTranslation(["forms"]);
  const [branch, setBranch] = useState({ id: -1, name: t("all") });
  const tb = {
    wait: true,
    Branch: true,
    stor: { ...sto, branchi: branch.id == -1 ? invData.branch : branch.id },
    parms: {
      branch: branch.id == -1 ? invData.branch : branch.id,
      iempid: sto.empi,
    },

  };

  const { object: AutoOptionsB, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
    [branch]
  );

  const tttb = {
    /*other:true,*/ // out
    wait: true,
    other: true,
    Users: true,
    Stocks: true, // Error // out
    Banks: true,
    Customers: true,
    // salesmen: true,
    costcenters: true,
    // Employees: true,
    CheckStatus: true,
    /*params*/ // out
    PermissionsElemnts: true,
    /*params*/ // out
    parms: {
      ibranchid: branch.id == -1 ? invData.branch : branch.id, iempid: sto.empi,
      iuserid: sto.idi,
      scurrenciestype: 'I',
      branch: branch.id == -1 ? invData.branch : branch.id ,
      tname: "sandd",
      iformid: dataF[67].id,
    },
    autos: {
      Users: true,
      Safes: true,
      Stocks: true,
      Banks: true,
      // Employees: true,
      // salesmens: true,
      costcenters: true,
      CheckStatus: true,
    }
  }

  const url = uri + 'Res';

  const { object: AutoOptions, fetching: fetchinData, fetch: fetchURL } =
   useFetchObjectByPost(url, tttb,    [branch]   );

  useEffect(() => {
    console.log('customer', AutoOptions)
  })
  if (fetchinData || !AutoOptions?.Customers ||!AutoOptionsB?.Branches)
    return <BackdropScI />

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <EExchangeVoucher
        {...{
          ...props,
          AutoOptions: AutoOptions?.Customers ? AutoOptions : [],
          fetchURL,
          prmis: AutoOptions?.permisElm ?? insh.permiElm,
          invData,
          isDialog: false,
          isDialogData: true,
          AutoOptionsB: AutoOptionsB?.Branches? AutoOptionsB: [],
          branch,
          setBranch,
        }} />
    </Dialog>

  )
}


